import { render, staticRenderFns } from "./FinanceiroDashboard.vue?vue&type=template&id=4960e568&scoped=true"
import script from "./FinanceiroDashboard.vue?vue&type=script&lang=js"
export * from "./FinanceiroDashboard.vue?vue&type=script&lang=js"
import style0 from "./FinanceiroDashboard.vue?vue&type=style&index=0&id=4960e568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960e568",
  null
  
)

export default component.exports